import React, { useState } from 'react';
import Seo from '../components/Seo';
import { companyProfile } from '../content/siteContent';

const mapEmbedUrl = `https://maps.google.com/maps?q=${encodeURIComponent(companyProfile.registeredAddress)}&t=&z=15&ie=UTF8&iwloc=&output=embed`;

function ContactIcon({ children }) {
  return (
    <span className="contact-detail-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        {children}
      </svg>
    </span>
  );
}

const contactItems = [
  {
    title: 'Registered Base',
    detail: companyProfile.location
  },
  {
    title: 'Public Address',
    detail: companyProfile.registeredAddress
  },
  {
    title: 'Inquiry Route',
    detail: (
      <div className="contact-detail-stack">
        <a href="tel:+918758637022" className="contact-detail-link">
          <ContactIcon>
            <path d="M6.8 5.5h2.3l1.1 3.1-1.4 1.4a12 12 0 0 0 5.2 5.2l1.4-1.4 3.1 1.1v2.3c0 .5-.4.9-.9.9A12.5 12.5 0 0 1 5.9 6.4c0-.5.4-.9.9-.9Z" />
          </ContactIcon>
          <span>{companyProfile.phone}</span>
        </a>

        <a href={`mailto:${companyProfile.primaryEmail}`} className="contact-detail-link">
          <ContactIcon>
            <path d="M5 7.5h14v9H5z" />
            <path d="m6 8.5 6 4.5 6-4.5" />
          </ContactIcon>
          <span>{companyProfile.primaryEmail}</span>
        </a>

        <a href={`mailto:${companyProfile.secondaryEmail}`} className="contact-detail-link">
          <ContactIcon>
            <path d="M5 7.5h14v9H5z" />
            <path d="m6 8.5 6 4.5 6-4.5" />
          </ContactIcon>
          <span>{companyProfile.secondaryEmail}</span>
        </a>
      </div>
    )
  }
];

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    alert('Thank you for contacting Vedanskrix. We will get back to you shortly.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  return (
    <div className="inner-page">
      <Seo
        title="Contact Vedanskrix | Ahmedabad Website, Admission, Visa & Job Support"
        description="Contact Vedanskrix for website design, web development, mobile app, IoT, ethical hacking, admission guidance, visa guidance, SEO, and job placement inquiries."
        keywords={[
          'contact Vedanskrix',
          'Ahmedabad website design inquiry',
          'admission guidance inquiry Ahmedabad',
          'visa consultant inquiry Ahmedabad',
          'job placement support Ahmedabad',
          'seo company contact Ahmedabad',
          'web development inquiry Ahmedabad'
        ]}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          name: 'Contact Vedanskrix',
          url: `${companyProfile.websiteUrl}/contact`,
          description: 'Contact page for Vedanskrix website, app, SEO, admission, visa, and job placement services.',
          mainEntity: {
            '@type': 'Organization',
            name: companyProfile.legalName,
            telephone: companyProfile.phone,
            email: companyProfile.primaryEmail
          }
        }}
      />

      <section className="page-hero contact-hero">
        <h1>Contact</h1>
        <p>
          Reach out with your requirement and let Vedanskrix guide the next move.
        </p>
      </section>

      <section className="section section-light">
        <div className="contact-layout">
          <aside className="contact-panel">
            <p className="eyebrow">Reach Out</p>
            <h2>We reply with focus, not confusion.</h2>
            <p>
              Whether you need website help, guidance support, or career-focused assistance, this
              is the easiest place to start the conversation.
            </p>

            <div className="contact-cards">
              {contactItems.map((item) => (
                <div key={item.title} className="contact-card">
                  <h3>{item.title}</h3>
                  {typeof item.detail === 'string' ? <p>{item.detail}</p> : item.detail}
                </div>
              ))}
            </div>
          </aside>

          <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              name="name"
              placeholder="Your full name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              placeholder="name@example.com"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="phone">Phone</label>
            <input
              id="phone"
              type="tel"
              name="phone"
              placeholder="Optional"
              value={formData.phone}
              onChange={handleChange}
            />

            <label htmlFor="service">Service Needed</label>
            <select
              id="service"
              name="service"
              value={formData.service}
              onChange={handleChange}
              required
            >
              <option value="">Select a service</option>
              <option value="digital">Digital solutions</option>
              <option value="admission">Admission guidance</option>
              <option value="visa">Visa guidance</option>
              <option value="career">Career enablement</option>
            </select>

            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Tell us what you want to build or solve"
              value={formData.message}
              onChange={handleChange}
              required
            />

            <button type="submit" className="button-primary submit-button">
              Send Inquiry
            </button>
          </form>
        </div>
      </section>

      <section className="section">
        <div className="contact-map-section">
          <div className="section-heading left">
            <p className="eyebrow">Location Map</p>
            <h2>Visit the registered Vedanskrix base in Ahmedabad.</h2>
            <p>{companyProfile.registeredAddress}</p>
          </div>

          <div className="contact-map-frame">
            <iframe
              title="Vedanskrix location map"
              src={mapEmbedUrl}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
